import React from 'react'
import api from 'core/api/contentstack'
import syndigoApi from 'core/api/syndigo'
import references from 'core/api/references'
import Listing from 'core/components/Listing'
import { layoutData } from 'core/layout'
import { ProductCard } from 'core/components/Card'
import { toContentStack } from '../api/syndigo/transformations'
import { short } from 'core/helpers/string'
import { toListingItem } from 'core/helpers/listing'

const Products = (props: any) => <Listing {...props} card={ProductCard} useInfiniteScroll={true} />

export default Products

export async function getStaticProps(context: any) {
  const skip = 0
  const take = 380

  var locale = (context.locale || 'en-US').toLowerCase() == 'fr' ? 'fr-ca' : (context.locale || 'en-US').toLowerCase()

  let syndigoResults: any, result: any, layout: any
  try {
    ;[syndigoResults, result, layout] = await Promise.all([
      syndigoApi.getProductListing(locale, skip, take),
      api.getEntryByUrl('listing', `/products`, context.locale, [
        ...references.PRODUCT_LISTING,
        'featured_products.product'
      ]),
      layoutData(api, context.locale),
    ])
  } catch (err) {
    console.error('getStaticProps (products/index): fetch failed', err)
    return { notFound: true, revalidate: 60 }
  }

  var items: any[] = syndigoResults ? toContentStack(locale, syndigoResults.Results, true) : []

  items = items.map((item: any) => {
    item.short_title = short(item.title)
    return item
  })

  items = items.sort((a: any, b: any) =>
    !a.short_title ? 1 : !b.short_title ? -1 : a.short_title.localeCompare(b.short_title)
  )

  // revalidate: 60 — retry aggressively while CMS entry is missing or unavailable
  if (!result) return { notFound: true, revalidate: 60 }

  return {
    props: { layout: true, ...layout, items: items.map(toListingItem).filter(Boolean), result, prefix: 'products' },
    revalidate: 43200,
  }
}